<template>
  <div class="SubscriptionConsumptionEmptyPanel d-flex flex-column align-center justify-center text-center">
    <img
      v-if="iconSrc"
      :src="iconSrc"
      alt=""
      aria-hidden="true"
      class="SubscriptionConsumptionEmptyPanel__image mb-4"
    />
    <app-material-icon
      v-else-if="icon"
      :name="icon"
      v-bind="iconColor ? { color: iconColor } : {}"
      size="xl"
      :filled="!!iconColor"
      class="mb-4"
    />
    <p class="text--medium font-weight-bold text-text-primary" :class="text ? 'mb-1' : 'mb-0'">
      {{ title }}
    </p>
    <p v-if="text" class="mb-0 text--small text-text-secondary">
      {{ text }}
    </p>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  // Shared empty-state panel for the Data Room consumption tabs: pass a Material `icon` (with an
  // optional `iconColor`, which also switches it to the filled variant) or an image `iconSrc`, a
  // `title` and an optional `text`. The caller's `data-locator` falls through.
  export default defineComponent({
    name: 'SubscriptionConsumptionEmptyPanel',
    props: {
      title: {
        type: String,
        required: true,
      },
      text: {
        type: String,
        default: '',
      },
      icon: {
        type: String,
        default: '',
      },
      iconColor: {
        type: String,
        default: '',
      },
      iconSrc: {
        type: String,
        default: '',
      },
    },
  })
</script>

<style scoped lang="scss">
  .SubscriptionConsumptionEmptyPanel {
    min-height: 220px;
    background-color: rgb(var(--v-theme-surface-primary));
  }

  .SubscriptionConsumptionEmptyPanel__image {
    width: 48px;
    height: auto;
  }
</style>
